<template>
  <component :is="icon" />
</template>

<script>
import percepcion from "@/assets/img/percepcion.svg";
import vivencias from "@/assets/img/vivencias.svg";
import imagen from "@/assets/img/imagen.svg";
import riesgo from "@/assets/img/riesgo.svg";
import salud from "@/assets/img/salud.svg";
import sintomas from "@/assets/img/sintomas.svg";

export default {
  components: {
    percepcion,
    vivencias,
    imagen,
    riesgo,
    salud,
    sintomas,
  },
  props: {
    icon: {
      type: [String],
      default: "",
    },
  },
};
</script>
